import { ApprovalStatus } from '@opallabs/satellite/src/ApprovalItem/types'
import { NormalizedTask, NormalizedApproval } from '@opallabs/wormhole/types'
import { PreviewWorkflowItem } from './types'

export const NormalizedTaskToPreviewWorkflowItem = (
  task: NormalizedTask
): PreviewWorkflowItem => ({
  content: {
    id: task.contentId ? task.contentId : '',
    moment: {
      id: task.momentId ? task.momentId : '',
    },
  },
  dueDate: task.dueDate ? task.dueDate : new Date(),
  is_new: false,
  phase: {
    phase_type: 'task',
    name: task.taskText,
  },
  isDueAtDate: task.hardDueDate,
})

export const NormalizedApprovalToPreviewWorkflowItem = (
  approval: NormalizedApproval
): PreviewWorkflowItem => ({
  content: {
    id: approval.contentId ? approval.contentId : '',
    moment: {
      id: approval.momentId ? approval.momentId : '',
    },
  },
  completedAt: approval.completedAt,
  dueDate: approval.dueDate ? approval.dueDate : new Date(),
  is_new: false,
  is_approved: approval.approvalStatus === ApprovalStatus.complete,
  phase: {
    phase_type: 'approval',
    name: approval.approvalName ? approval.approvalName : 'Approval Phase',
  },
  isDueAtDate: approval.hardDueDate,
})
